<template>
  <div>
    <v-toolbar color="transparent" dense flat>
      <v-toolbar-title>{{$t('settings_backups')}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu bottom offset-y left>
        <v-btn icon slot="activator" class="mv-menu">
          <v-icon>more_vert</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile
            v-for="(item, index) in menu"
            :key="index"
            @click="menuItemClicked(item.key)"
          >
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <v-divider></v-divider>

    <v-list subheader class="pa-3">
      <template v-for="(item, index) in backups">
        <v-list-tile
          :key="item.name + index"
          @click="clicked(item)"
          @mouseover="mouseOver(index)"
        >
          <v-list-tile-content>
            <v-list-tile-title>{{item.name}}</v-list-tile-title>
          </v-list-tile-content>

          <div v-show="selected==index">
            <v-btn small @click="showRestoreBackupDialog">{{$t('data_backup_restore')}}</v-btn>
          </div>

        </v-list-tile>
      </template>
      <div v-if="!backups || backups.length==0">{{$t('data_backup_no_data')}}</div>
    </v-list>

    <v-dialog
      v-model="createBackupDialog"
      max-width="350"
    >
      <v-card>
        <v-card-title class="headline">{{ this.$t('data_backup_new_title') }}</v-card-title>
        <form class="pa-3">
            <v-text-field
              :label= "$t('acc_pass_hint')" 
              name="password"
              v-model="password" 
            ></v-text-field>
            <v-text-field
              name="confirm_password" 
              :label="$t('acc_pass_confirm_hint')"
              v-model="confirmPassword"
            ></v-text-field>
            <v-text-field
              name="name" 
              :label="$t('contacts_name')"
              v-model="name"
            ></v-text-field>
            <v-switch v-model="withMediaData" :label="$t('data_backup_new_media_data')"></v-switch>
        </form>

        <v-card-actions>
          <v-btn flat @click="createBackupDialog = false">
            {{ this.$t('cancel') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            flat="flat"
            :disabled="nextDisabled"
            :loading="loading"
            @click="createBackup"
          >
            {{ this.$t('next_btn') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="restoreBackupDialog"
      max-width="350"
    >
      <v-card>
        <v-card-title class="headline">{{ this.$t('data_backup_restore_dialog_title') }}</v-card-title>
        <v-card-text>{{ this.$t('data_backup_enter_password') }}</v-card-text>
        <form class="pa-3">
          <v-text-field
            :label= "$t('acc_pass_hint')" 
            name="password"
            v-model="password" 
          ></v-text-field>
        </form>
        <v-card-actions>
          <v-btn flat @click="restoreBackupDialog = false">
            {{ this.$t('cancel') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            flat="flat"
            :loading="loading"
            @click="restoreBackup"
          >
            {{ this.$t('next_btn') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>  
</template>

<style>
</style>

<script>
const MenuId = {
    menu_new_backup: 0,
}

  export default {
    components: { 
      
    },
    data () {
      return {
        backups: [],
        createBackupDialog: false,
        password: '',
        confirmPassword: '',
        name: '',
        withMediaData: false,
        loader: null,
        loading: false,
        selected: -1,
        restoreBackupDialog: false,
        restoreBackupItem: null,
        menu: [
          { title: this.$t('data_backup_new_header'), key: MenuId.menu_new_backup },
        ],
      }
    },
    mounted() { 
      this.fetchBackups()
    },
    computed: {
      nextDisabled() {
        return !this.validate(this.password, this.confirmPassword, this.name)
      }
    },
    methods: {
      fetchBackups() {
        this.backups = []
        this.$store.dispatch('getBackups').then(items => {
          this.backups = items
        })
      },
      mouseOver(index) {
        this.selected = index
      },
      createBackup() {
        this.loader = 'loading'
        const l = this.loader

        this.$store.dispatch('createBackup', { 
          name: this.name, 
          password:this.password, 
          withMedia: this.withMediaData 
        }).then(() => {
          this[l] = false
          this.loader = null
          this.createBackupDialog = false
          this.password = ''
          this.confirmPassword = ''
          this.name = ''
          // update listing
          this.fetchBackups()
        })
      },
      restoreBackup() {
        this.loader = 'loading'
        const l = this.loader

        let it = this.backups[this.selected]
        this.$store.dispatch('restoreBackup', { filepath:it.filepath, password:this.password }).then(() => {
          this[l] = false
          this.loader = null
          this.restoreBackupDialog = false
          this.password = ''
          // reload main UI
          this.$router.push({name:"LanguageLoader"})
        })
      },
      clicked(item) {
        // just an empty method
      },
      validate(password, confirm, name) {
        if (password !== '' && confirm === password) {
          return (name !== '')
        }
        return false
      },
      showRestoreBackupDialog() {
        const l = this.loader
        this[l] = false   
        this.password = '' 
        this.restoreBackupDialog = true
      },
      menuItemClicked(key) {
        switch (key) {
          case MenuId.menu_new_backup:
            this.createBackupDialog = true
            break
          default:
            throw new Error('-- unknown key: ' + key)
        }
      },
    },
    watch: {
      loader () {
        const l = this.loader
        this[l] = !this[l]
        /*setTimeout(() => {
          this[l] = false
          // TODO: show error
        }, 5000)*/
        this.loader = null
      }
    }
  }
</script>

